import { timesheetsOverviewState } from '../timesheets/timesheets.states';
import {
    EmployeesService,
    IAccount,
    IShift,
    ShiftService,
    ITeam,
    Masterdata,
    IEmployee
} from '../../services';
import * as moment from 'moment';
import { AuthService } from "../../authorization/services/index";
import { AccountsService } from '../../services/accounts.service';
import { IEmployeeAvailability } from '../../services/employeeAvailability.service';

interface IResolve {
    shift: IShift;
    accounts: IAccount[];
    functions: Masterdata[];
    employees: IEmployee;
    statuses: Masterdata[];
}

interface IScope extends ng.IScope {
    shiftForm: ng.IFormController;
}

class ShiftListItemController implements ng.IComponentController {
    currentShiftStatus: number;
    private onChange: any;
    private employees: any;
    private functions: Masterdata[];
    private statuses: Masterdata[];
    private accounts: IAccount[];
    private locations: any;
    private teams: ITeam[];
    private resolve: IResolve;
    private shift: IShift;
    private employeeNote: string;
    private employeeAvailability: IEmployeeAvailability[];
    private selectedEmployee: any;
    private mode: string;
    private currentDate: any;

    private sortType: string;

    private isBackoffice = false;
    private isCustomer = false;
    private isEmployee = false;

    constructor(
        private ShiftService: ShiftService,
        private EmployeesService: EmployeesService,
        private AccountsService: AccountsService,
        private AuthService: AuthService,
        private $stateParams: ng.ui.IStateParamsService,
        private $state: ng.ui.IStateService,
        private $timeout: ng.ITimeoutService,
        private $scope: IScope,
        private SweetAlert: any
    ) {
        'ngInject';
    }

    public $onInit = () => {
        this.onChange({ type: 'open', data: this.shift });

        if (!this.employees.find(e => e.displayName === '--- Geen ---')) {
            var emp = new IEmployee();
            emp.displayName = '--- Geen ---';
            this.employees.push(emp);
        }

        if (this.shift) {
            if (moment().isAfter(this.shift.start)) {
                this.shift.isInThePast = true;
            }
            this.currentShiftStatus = this.shift.status;
        } else {
            this.shift = new IShift();
            this.shift.start = this.roundMinutes(new Date());
            this.shift.end = moment(this.shift.start).add(8, 'hour').toDate();
            this.shift.status = 2;

            // if (this.AuthService.hasRole('customer')) {
            //     this.shift.status = 6;
            // }
            if (this.$stateParams['status']) {
                this.shift.status = this.$stateParams['status'];
            }
            this.shift.employeeId = null;
        }

        if (this.AuthService.hasRole('customer')) {
            this.shift.teamLocationAccountId = this.AuthService.getTokenData().customerId;
        }

        if (this.shift.teamLocationAccountId) {
            this.AccountsService.getChild(this.shift.teamLocationAccountId, 'locations').then((result) => {
                this.locations = result;
                if (this.shift.teamLocationId) {
                    this.teams = this.locations.find(item => item.id === this.shift.teamLocationId).teams;
                }
            });
        }

        this.currentDate = new Date(Date.now());

        this.isBackoffice = this.AuthService.hasRole('backoffice');
        this.isCustomer = this.AuthService.hasRole('customer');
        this.isEmployee = this.AuthService.hasRole('employee');
    }

    $onDestroy = () => {
        this.onChange({ type: 'close', data: this.shift });
    }

    roundMinutes(date) {
        var coeff = 1000 * 60 * 15;
        return new Date(Math.round(date.getTime() / coeff) * coeff);
    }

    // startDateBeforeRender($dates) {
    // }

    // endDateBeforeRender($view, $dates) {
    //     // console.log('endDateBeforeRender');
    //     if (this.shift.start) {
    //         var activeDate = moment(this.shift.start).subtract(1, $view).add(1, 'minute');

    //         $dates.filter(function (date) {
    //             return date.localDateValue() <= activeDate.valueOf();
    //         }).forEach(function (date) {
    //             date.selectable = false;
    //         });
    //     }
    // }

    public selectEmployee = () => {
        if (this.shift.employeeId) {
            this.shift.status = 6;
        } else {
            this.shift.status = 2;
        }
    }

    public selectedAccount() {
        this.AccountsService.getChild(this.shift.teamLocationAccountId, 'locations').then((result) => {
            this.locations = result;
        });
    }

    public locationSelected() {
        if (this.shift.teamLocationId) {
            let location = this.locations.find(item => item.id === this.shift.teamLocationId);
            this.teams = location ? location.teams : [];
        }
    }

    public submitShift(after = null) {
        this.$scope.shiftForm.$setSubmitted();
        if (this.$scope.shiftForm.$valid) {
            if (this.isCustomer && moment().isAfter(this.shift.start)) {
                this.SweetAlert.swal('Dienst in het verleden', 'U kunt geen dienst in het verleden creëren.', 'warning');
            } else if (moment(this.shift.start).isAfter(this.shift.end)) {
                this.SweetAlert.swal('Let op!', 'Eindtijd ligt voor starttijd.', 'warning');
            } else if (moment().isAfter(this.shift.start)) {
                this.SweetAlert.swal({
                    title: 'Let op!',
                    text: 'Deze dienst is in het verleden. Weet je zeker dit zeker?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#2ECC71',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ja, opslaan',
                    cancelButtonText: 'Nee, annuleren',
                }, (isConfirm) => {
                    if (isConfirm) {
                        this.currentShiftStatus = this.shift.status;
                        this.save(after);
                    } else {

                    }
                });
            } else if ((this.shift.status === 92 || this.shift.status === 7) && moment().add(4, 'day').isAfter(moment(this.shift.start))) {
                // console.log("HERE")
                if (!this.shift.employeeId) {
                    // console.log("1")
                    this.SweetAlert.swal({
                        title: 'Let op!',
                        text: 'Let op: de dienst begint over minder dan 96 uur. Er is geen medewerker geselecteerd waarop een decalartie kan worden aangemaakt. Je kunt deze dienst niet annuleren',
                        type: 'warning',
                        showCancelButton: false,
                        confirmButtonColor: '#2ECC71',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Stop',
                    }, (isConfirm) => {
                        if (isConfirm) {
                        } else {
                        }
                    });
                } else {
                    // console.log("2")
                    this.SweetAlert.swal({
                        title: 'Let op!',
                        text: 'Let op: de dienst begint over minder dan 96 uur. Er worden automatisch een declaratie aangemaakt. Weet u zeker dat u de dienst wilt annuleren?',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#2ECC71',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Ja, opslaan',
                        cancelButtonText: 'Nee, annuleren',
                    }, (isConfirm) => {
                        if (isConfirm) {
                            this.shift.status = 7;
                            this.currentShiftStatus = this.shift.status;
                            this.save(after);
                        } else {
                        }
                    });
                }
            } else if ((this.currentShiftStatus === 7  && this.shift.status != 7)) {
                // console.log("3")
                this.SweetAlert.swal({
                    title: 'Let op!',
                    text: 'Let op: Deze dienst had status Geannuleerd 96 uur. Bij het opslaan zullen alle declaraties worden verwijderd. Weet je zeker dat je dit wilt?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#2ECC71',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Ja, opslaan',
                    cancelButtonText: 'Nee, annuleren',
                }, (isConfirm) => {
                    if (isConfirm) {
                        this.currentShiftStatus = this.shift.status;
                        this.save(after);
                    } else {
                    }
                });
            } else {
                this.currentShiftStatus = this.shift.status;
                this.save(after);
            }
        }
    }

    public save = (after) => {
        this.shift.start = moment(this.shift.start).format("YYYY-MM-DD HH:mm");
        this.shift.end = moment(this.shift.end).format("YYYY-MM-DD HH:mm");

        if (!this.shift.id) {
            this.ShiftService.post(this.shift).then((data) => {
                this.shift = data;
                this.handleAfterSubmit(after, 'new');
            });
        } else {
            this.ShiftService.put(this.shift.id, this.shift).then((data) => {
                this.shift = data;
                this.handleAfterSubmit(after, 'updated');
            });
        }
    }

    private deleteShift = () => {
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u deze dienst wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.ShiftService.delete(this.shift.id).then(() => {
                    this.onChange({ type: 'deleted', data: this.shift });
                    this.$state.go('^');
                });
            } else {

            }
        });
    }

    private handleAfterSubmit = (after, type) => {
        switch (after) {
            case "copy": {
                this.onChange({ type: 'copy', data: this.shift });
                //this.$state.go('.', {'id': ''}, {notify: false});
                this.shift.id = null;
                // this.shift.start = moment(this.shift.start).add(1, 'day').toDate();
                // this.shift.end = moment(this.shift.end).add(1, 'day').toDate();
                if (moment().isAfter(this.shift.start)) {
                    this.shift.isInThePast = true;
                } else {
                    this.shift.isInThePast = false;
                }

                break;
            }
            case "new": {
                this.onChange({ type: 'copy', data: this.shift });
                this.shift = null;
                this.$state.go('shifts.list.item', { 'id': '' });
                break;
            }
            default: {
                this.$state.go('shifts.list.item', { 'id': this.shift.id });
                this.onChange({ type: "new", data: this.shift });
            }
        }
    }
}

export const shiftListItemComponent: ng.IComponentOptions = {
    bindings: {
        shift: '<',
        employees: '<',
        statuses: '<',
        accounts: '<',
        functions: '<',
        onChange: '&',
    },
    controller: ShiftListItemController,
    template: <string>require('./shift.list.item.html')
};


// WEBPACK FOOTER //
// ./src/app/modules/shifts/shift.list.item.component.ts